import React, { useEffect, useState } from "react";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
import DataGridComponent from "../../../Components/Forms/DataGridProComponent";
import parse from 'html-react-parser';

const ControleDocaDetalheViagemPopup = (props: any) => {
    const [detalhes, setDetalhes] = useState<any>([]);
        const [loading, setLoading] = useState(false);

    const colunas: any[] = [
        { dataIndex: 'placa', title: 'Placa', width: 100, minWidth: 100 },
        { dataIndex: 'numero_doca', title: 'Doca', width: 100, minWidth: 100 },
        { dataIndex: 'transportador', title: 'Transportadora', width: 100, minWidth: 100 },
        { dataIndex: 'documento', title: 'Doc. Cliente', width: 100, minWidth: 100 },
        { dataIndex: 'tipo', title: 'Tipo', width: 150, minWidth: 150 },
        { dataIndex: 'datahora', title: 'Data hora', width: 150, minWidth: 150 },
        { dataIndex: 'observacao', title: 'Observação', width: 150, minWidth: 150 },
        { dataIndex: 'ignicao', title: 'Ignição', width: 150, minWidth: 150 },
        { dataIndex: 'velocidade', title: 'Velocidade', width: 100, minWidth: 100 },
        { dataIndex: 'localizacao', title: 'Localização', width: 100, minWidth: 100, render: (value: string) => parse(`${(value  ?? '')}`) },
        { dataIndex: 'usuario', title: 'Usuário', minWidth: 100, flex: 0.1, },
    ];

    useEffect(() => {(async () => await inicializaAsync())()}, []); 
    
    async function inicializaAsync() {
        setLoading(true);
        let response = await axios.get(`painelControleDoca/docaDetalhes?doca_id=${props.docaSelecionada.id}`);
        setDetalhes(response);
        setLoading(false);
    }

    return (
        <div>
            <BasePopup title={"Detalhes da Placa ("+props.docaSelecionada.placa + ")"} isOpen={props.isOpen} onClose={props.onClose} hideButtonNew={true}>
                <DataGridComponent
                    heightFix={250}
                    responseRows={detalhes}
                    paginationSide="client"
                    hideButtons={true}
                    columns={colunas} />
            </BasePopup>
        </div>
    );
}

export default ControleDocaDetalheViagemPopup;